import Vue from 'vue'

const state = {
  categories: [],
  isRequestSuceeded: false,
};

const mutations = {
  'SET_CATEGORIES' (state, categories) {
    state.categories = categories;
  },
  'SET_REQUEST_STATUS' (state, bool) {
    state.isRequestSuceeded = bool;
  },
};

const actions = {
  getCategories: ({commit}, info) => {
    return Vue.http.get('webstore/categories?token=' + info.token)
      .then(res => {
        return res.json();
      }, err => {
        return err.json();
      }).then(data => {
        if (!data.error) {
          commit('SET_REQUEST_STATUS', true);
          commit('SET_CATEGORIES', data.categories);
        }
        return data;
      })
      .catch(() => {
        commit('SET_REQUEST_STATUS', false);
      });
  },
};

const getters = {
  categories: state => {
    return state.categories;
  },
  categoryBooks: state => id => {
    const targetCategory = state.categories.find(obj => {
      return obj.id_category === id;
    });
    if (targetCategory) {
      return targetCategory.book_list;
    } else {
      return [];
    }
  },
  isCategoryRequestSuceeded: state =>  {
    return state.isRequestSuceeded;
  }
}

export default {
  state,
  mutations,
  actions,
  getters
}



// WEBPACK FOOTER //
// ./src/store/modules/categories.js